import {
  Edit,
  useNotify,
  SimpleForm,
  Toolbar,
  SaveButton,
  useRecordContext,
  useStore,
  type EditProps,
} from "react-admin";
import { NiyaazForm } from "../common/NiyaazForm";
import { validateFamilyMembers, validateMehmaans } from "../common/validate-niyaaz-members";
import { isAsharaEvent } from "@/utils";
import type { CurrentEvent } from "@/containers/events/types";

const EditToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
);

export const NiyaazEdit = (props: EditProps) => {
  const notify = useNotify();
  const [currentEvent] = useStore<CurrentEvent | null>("currentEvent");
  const onFailure = (error: Error) => {
    notify(`Could not edit post: ${error.message}`);
  };

  const validateNiyaazUpdation = (values: Record<string, unknown>) => {
    const errors: Record<string, unknown> = {};
    if (!values.markaz) {
      errors.markaz = isAsharaEvent(currentEvent ?? undefined)
        ? "The venue is required"
        : "The markaz is required";
    }
    if (!isAsharaEvent(currentEvent ?? undefined) && !values.namaazVenue) {
      errors.namaazVenue = "The namaaz venue is required";
    }
    if (!values.HOFId) {
      errors.HOFId = "The HOF ITS is required";
    }
    if (!values.HOFName) {
      errors.HOFName = "The HOF Name is required";
    }
    const familyMembersError = validateFamilyMembers(
      values.familyMembers as Parameters<typeof validateFamilyMembers>[0],
      false
    );
    if (familyMembersError) {
      errors.familyMembers = familyMembersError;
    }

    if (isAsharaEvent(currentEvent ?? undefined)) {
      const mehmaansError = validateMehmaans(
        values.mehmaans as Parameters<typeof validateMehmaans>[0]
      );
      if (mehmaansError) {
        errors.mehmaans = mehmaansError;
      }
    }
    return errors;
  };

  return (
    <Edit {...props} onFailure={onFailure} title={<NiyaazEditTitle />}>
      <SimpleForm
        warnWhenUnsavedChanges
        toolbar={<EditToolbar />}
        validate={validateNiyaazUpdation}
        sx={{ maxWidth: 1200 }}
      >
        <NiyaazForm mode="edit" />
      </SimpleForm>
    </Edit>
  );
};

const NiyaazEditTitle = () => {
  const record = useRecordContext<{ formNo?: string }>();
  return <span>{record ? `Form No. ${record.formNo}` : ""}</span>;
};
